import React from "react"
import { Polyline as GooglePolyline } from "@react-google-maps/api"
import PropTypes from "prop-types"
import activePolylineSubject from "utils/activePolylineSubject"

const Polyline = ({ path, options, type, id, onPolylineClick }) => {
  const handleMouseOver = () => {
    activePolylineSubject.notify({ action: "hover", value: type })
  }

  const handleMouseOut = () => {
    activePolylineSubject.notify({ action: "hover", value: null })
  }

  const handleClick = () => {
    activePolylineSubject.notify({ action: "click", value: type })
    onPolylineClick()
  }

  return (
    <GooglePolyline
      key={id}
      path={path}
      options={options}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      onClick={handleClick}
    />
  )
}

Polyline.propTypes = {
  options: PropTypes.shape({}).isRequired,
  path: PropTypes.arrayOf(PropTypes.any).isRequired,
  type: PropTypes.string,
  id: PropTypes.string.isRequired,
  onPolylineClick: PropTypes.func,
}
Polyline.defaultProps = {
  type: null,
  onPolylineClick: () => null,
}
export default Polyline
